import React, { useContext } from 'react';

import LabelName from 'components/UI/LabelName/LabelName';

import { UserDetailsContext } from 'context/userDetailsContext';
import { handleDateTimeOffset } from 'utils/utility_functions/timezone';
import constants from 'constants/index';
import { useConferenceRooms } from 'hooks/useConferenceRooms';

function GoogleAndOutlookPreview({ eventDetails }) {
  const userContext = useContext(UserDetailsContext);
  const { conferenceRoomOptions } = useConferenceRooms();

  let event_type = eventDetails?.extendedProps?.res_type;
  let calendar_url = eventDetails?.extendedProps?.calendar_link;
  let meet_url = eventDetails?.extendedProps?.meet_link;

  // Function to get conference room name by ID
  const getConferenceRoomName = (roomId) => {
    if (!roomId || !conferenceRoomOptions) return null;
    const room = conferenceRoomOptions.find((room) => room.value === roomId);
    return room?.label || null;
  };

  function navigateTo(e, url) {
    e.preventDefault();
    window.open(url, '_blank');
  }

  return (
    <form>
      {/* form heading */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="modal-heading F-size16 text-bold">{event_type === 'google' ? 'Google Meet' : 'Outlook Event'}</div>
      </div>
      {/* title */}
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12 ">
          <LabelName required={false} htmlFor="title">
            Event Title
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">{eventDetails?.title}</div>
      </div>
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="title">
            Date
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">
          {handleDateTimeOffset(userContext.userDetails.timezone, eventDetails?.start, constants.month_date_year_format)}
        </div>
      </div>
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="title">
            Time
          </LabelName>
        </div>
        <div className="col-md-8 col-12 d-flex gap-3 align-items-center">
          <div className="w-100 input-style">
            {handleDateTimeOffset(userContext.userDetails.timezone, eventDetails?.start, constants.hour_minute_12_format)}
          </div>
          <div className="text-bold">-</div>
          <div className="w-100 input-style">
            {handleDateTimeOffset(userContext.userDetails.timezone, eventDetails?.end, constants.hour_minute_12_format)}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="conference_room">
            Conference Room
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">
          {(() => {
            const roomName =
              eventDetails?.room_name ||
              eventDetails?._conference_room_ ||
              getConferenceRoomName(eventDetails?.conference_room_id) ||
              getConferenceRoomName(eventDetails?.conference_room) ||
              eventDetails?.extendedProps?.room_name ||
              eventDetails?.extendedProps?._conference_room_ ||
              getConferenceRoomName(eventDetails?.extendedProps?.conference_room_id) ||
              getConferenceRoomName(eventDetails?.extendedProps?.conference_room);
            return roomName || 'None';
          })()}
        </div>
      </div>
      {event_type === 'google' && meet_url ? (
        <div className="d-flex align-items-center py-2 flex-wrap">
          <div className="col-md-4 col-12">
            <LabelName required={false} htmlFor="title">
              Meet link
            </LabelName>
          </div>
          <div className="col-md-8 col-12 d-flex gap-3 align-content-center">
            <button className="btn btn-primary" onClick={(e) => navigateTo(e, meet_url)}>
              Join With Google Meet
            </button>
          </div>
        </div>
      ) : (
        <>
          {meet_url && (
            <div className="d-flex align-items-center py-2 flex-wrap">
              <div className="col-md-4 col-12">
                <LabelName required={false} htmlFor="title">
                  Meet link
                </LabelName>
              </div>
              <div className="col-md-8 col-12 d-flex gap-3 align-content-center">
                <button className="btn btn-primary" onClick={(e) => navigateTo(e, meet_url)}>
                  Join With Skype
                </button>
              </div>
            </div>
          )}
        </>
      )}
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="title">
            {/* Calendar link */}
          </LabelName>
        </div>
        <div className="col-md-8 col-12 d-flex gap-3 align-content-center">
          <a href="http://" target="_blank" rel="noopener noreferrer" onClick={(e) => navigateTo(e, calendar_url)}>
            More Details
          </a>
        </div>
      </div>
    </form>
  );
}

export default GoogleAndOutlookPreview;
